<template>
  <div class="nozzle-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('nozzle_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.nozzles')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <NozzleFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import NozzleFilterForm from '../../components/nozzle/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'NozzleList',
  servicePrefix: 'Nozzle',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    NozzleFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.nozzle.name'), value: 'name' },
        { text: this.$t('profile.nozzle.type'), value: 'type.name' },
        { text: this.$t('profile.nozzle.visual'), value: 'visual.name' },
        { text: this.$t('global.archive'), value: 'archive' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('nozzle', {
      items: 'list'
    }),
    ...mapFields('nozzle', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('nozzle', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
